import React from 'react';
import { Pencil, Lock, ShieldOff } from 'lucide-react';

const MyAccount = () => {
  const user = {
    name: 'Ahmad Mukhtar',
    email: 'ahmad@agentic.ai',
    role: 'Admin',
    organization: 'Selfic AI',
    timezone: 'America/New_York',
    status: 'Active',
  };

  return (
    <div className="max-w-4xl mx-auto space-y-8">
      {/* Title */}
      <div>
        <h2 className="text-xl font-semibold text-white">My Account</h2>
        <p className="text-sm text-gray-400">Manage your profile, credentials, and preferences.</p>
      </div>

      {/* Profile Section */}
      <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 shadow">
        <div className="flex items-center gap-6">
          <div className="w-20 h-20 rounded-full bg-indigo-500 flex items-center justify-center text-white text-xl font-bold">
            {user.name.charAt(0)}
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-medium text-white">{user.name}</h3>
            <p className="text-sm text-gray-400">{user.email}</p>
            <p className="text-sm text-gray-400">Role: <span className="text-indigo-400">{user.role}</span></p>
          </div>
          <button className="text-sm text-indigo-400 hover:text-white flex items-center">
            <Pencil className="w-4 h-4 mr-1" /> Edit Profile
          </button>
        </div>
      </div>

      {/* Account Info */}
      <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 shadow">
        <h4 className="text-white font-semibold mb-4">Account Info</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-gray-300">
          <div>
            <span className="text-gray-500">Organization</span>
            <p>{user.organization}</p>
          </div>
          <div>
            <span className="text-gray-500">Timezone</span>
            <p>{user.timezone}</p>
          </div>
          <div>
            <span className="text-gray-500">Status</span>
            <p className="text-green-400">{user.status}</p>
          </div>
        </div>
      </div>

      {/* Licensing / Billing Section */}
      <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 shadow">
        <h4 className="text-white font-semibold mb-4">License & Billing</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-gray-300">
          <div>
            <span className="text-gray-500">Plan</span>
            <p className="text-indigo-400 font-medium">Agentic Pro</p>
          </div>
          <div>
            <span className="text-gray-500">License Status</span>
            <p className="text-green-400">Active</p>
          </div>
          <div>
            <span className="text-gray-500">Usage</span>
            <p>8 / 25 Workflows | 3 / 5 LLMs</p>
          </div>
          <div>
            <span className="text-gray-500">Next Payment</span>
            <p>June 5, 2025</p>
          </div>
        </div>

        <div className="mt-6 flex gap-4 flex-wrap">
          <button className="text-sm text-white bg-indigo-600 hover:bg-indigo-700 px-4 py-2 rounded-md shadow">
            Manage Billing
          </button>
          <button className="text-sm text-gray-300 hover:text-white border border-neutral-700 px-4 py-2 rounded-md">
            Upgrade Plan
          </button>
        </div>
      </div>


      {/* Security Actions */}
      <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 shadow">
        <h4 className="text-white font-semibold mb-4">Security</h4>
        <div className="space-y-3">
          <button className="flex items-center gap-2 text-sm text-yellow-400 hover:text-yellow-300">
            <Lock className="w-4 h-4" /> Change Password
          </button>
          <button className="flex items-center gap-2 text-sm text-red-400 hover:text-red-300">
            <ShieldOff className="w-4 h-4" /> Deactivate Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyAccount;
